import breakpoints, { maxWidthBreakpoint } from "../settings/breakpoints";
export default breakpoint =>
  `@media screen and (min-width: ${breakpoints[breakpoint]})`;

export const maxWidth = breakpoint =>
  `@media (max-width: ${maxWidthBreakpoint[breakpoint]})`;



// WEBPACK FOOTER //
// ./styles/tools/breakTo.js